import React from "react";
import "../styles/HotelTopBar.css";
import { useGame } from "../GameContext";
import formatTime from "./hooks/formatTime";

const TopBar: React.FC = () => {
  const {
    message,
    setHelpPanelOpen,
    isGameStarted,
    time,
  } = useGame();
  return (
    <div className="hotel-top-bar-button">
      <div className="hotel-top-bar">
        
        <div className="hotel-message-bar">{message}</div>
        <img
          className="hotel-icon help"
          alt="Помощь"
          src="/img/help.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
        {isGameStarted && (
          <p className="hotel-subtitle">Таймер: {formatTime(time)}</p>
        )}
      </div>
    </div>
  );
};

export default TopBar;
